import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHandHeart = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M25 23H26.838C27.4677 23.0001 28.0815 23.1983 28.5923 23.5666C29.1031 23.9349 29.485 24.4545 29.684 25.052L30 26L18.532 29.529C17.5488 29.8313 16.4869 29.7432 15.567 29.283L9 26V19H10C11.105 19 13.906 19.438 15 21H18C19.0609 21 20.0783 21.4214 20.8284 22.1716C21.5786 22.9217 22 23.9391 22 25H16",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M27.2 9.81202C26.9163 9.52219 26.5709 9.30001 26.1895 9.16199C25.8081 9.02397 25.4005 8.97365 24.997 9.01477C24.5935 9.05589 24.2044 9.18739 23.8587 9.39951C23.513 9.61163 23.2195 9.89891 23 10.24C22.7806 9.89891 22.4871 9.61163 22.1414 9.39951C21.7957 9.18739 21.4066 9.05589 21.0031 9.01477C20.5996 8.97365 20.192 9.02397 19.8106 9.16199C19.4292 9.30001 19.0838 9.52219 18.8 9.81202C18.2873 10.3354 18.0001 11.0389 18.0001 11.7715C18.0001 12.5042 18.2873 13.2077 18.8 13.731L23 18L27.2 13.731C27.7128 13.2077 27.9999 12.5042 27.9999 11.7715C27.9999 11.0389 27.7128 10.3354 27.2 9.81202V9.81202Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgHandHeart);
export default ForwardRef;
